interface EmptyStateProps {
  onReload: () => void;
}

const EmptyState = ({ onReload }: EmptyStateProps) => {
  return (
    <div className="text-center py-16">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <span className="text-4xl text-gray-400">📝</span>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        Nenhuma tarefa encontrada
      </h3>
      <p className="text-gray-600 mb-6">
        Não foi possível carregar as tarefas da API
      </p>
      <button
        onClick={onReload}
        className="bg-blue-600 text-white px-6 py-3 rounded-xl font-medium hover:bg-blue-700 transition-colors"
      >
        Tentar novamente
      </button>
    </div>
  );
};

export { EmptyState };
